<template>
  <div class="card">
    <img src="https://h5.chuxingyouhui.com/shop/assets/vscode-test/card.png"/>
  </div>
</template>
<script>
export default {
  name: 'Card',
};
</script>
<style lang="scss" scoped>
@import '../scale.scss';
.card {
  width: 344px * $scale;
  height: 223px * $scale;
  padding: 55px * $scale 143px * $scale 60px * $scale 143px * $scale;
  img {
    width: 100%;
    height: 100%;
    vertical-align: bottom;
    object-fit: cover;
  }
}
</style>
